import React from "react";
import { Modal } from "react-bootstrap";
import TextQuestionsGrid from "./Grid/TextQuestionsGrid";

const QuestionModal = (props) => {
  return (
    <div className="input-id-modal">
      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props.questionNo}.&nbsp;
            {props.QuestionText}
            <small className="total-responses d-block mt-2 text-muted">Responses: {props.popupdata.length}</small>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="individual-graph popup-table">
            <TextQuestionsGrid
              gridData={props.popupdata}
              surveyDetails={props.surveyDetails}
              QuestionText={props.QuestionText}
              QuestionNo={props.questionNo}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default QuestionModal;
